module.exports = __webpack_public_path__ + "img/mail-x1.7e08a83e.svg";